<template>
    <p class="input__field" style="margin-bottom: 0px">
        <label for="first" class="swich__box">
            <input type="checkbox" id="first" class="swich__input" :checked="props.isChecked" @change="onChanged" />
            <span class="slider round"></span>
        </label>
    </p>
</template>

<script setup>
import { onMounted, ref, watch, computed, defineEmits, defineProps } from 'vue';

const props = defineProps({
    isChecked: {
        default: false,
    },
});
const emit = defineEmits(['onReturn']);

// const isChecked = ref(props.isChecked);
// const aaaaa = computed(() => {
//     return props.isChecked;
// });

const onChanged = (event) => {
    // console.log('toggle  onChanged : start', event.target.checked);
    emit('onReturn', event.target.checked);
};
// onMounted(() => {
//     console.log('tttest onMounted : start');
// });
</script>

<style scoped lang="scss">
.Normal {
    background-color: antiquewhite;
}

.Checked {
    background-color: aqua;
}
</style>
